import styled from "styled-components";
export const OrderContainer = styled.section`
  .order {
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    display: flex;
    margin: 20px 0;
    margin-top: 0;
    flex-wrap: wrap;
    overflow: hidden;
    justify-content: space-between;
    background-color:#fff;
    .item {
      padding: 16px 8px;
      weight: 100%;
    }
  }
`;
